/* cart-rewards-bar.js (OPTIONAL — progressive enhancement only)
   The bar recomputes server-side every time the cart-drawer section re-renders
   (see cart-drawer.js getSectionsToRender), so nothing here is required for
   correctness. This file:
     1. Re-animates the progress fill from 0 on each (re)render (the innerHTML
        swap replaces the element, so a CSS transition can't tween across it).
     2. Opens the "Unlock special offers" list on DESKTOP only when the server
        marked it auto-open (data-pw-autoopen="true"). It stays collapsed by
        default — and on mobile — so the cart items + checkout aren't pushed
        down by a tall expanded list. The native <summary> toggle always works.

   Loaded from snippets/cart-drawer.liquid alongside the other cart scripts.
*/
(function () {
  var DESKTOP = '(min-width: 768px)';

  function animate(root) {
    var fill = root.querySelector('.pw-rewards__fill');
    if (!fill) return;
    var target = fill.style.width || '0%';
    fill.style.width = '0%';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { fill.style.width = target; });
    });
  }

  function autoOpen(root) {
    var details = root.querySelector('.pw-rewards__gifts');
    if (!details) return;
    var wants = details.getAttribute('data-pw-autoopen') === 'true';
    // Open only on desktop; never force-collapse a list the shopper opened.
    if (wants && window.matchMedia(DESKTOP).matches) details.open = true;
  }

  function run() {
    document.querySelectorAll('.pw-rewards').forEach(function (root) {
      animate(root);
      autoOpen(root);
    });
  }

  document.addEventListener('DOMContentLoaded', run);

  // Re-run whenever the cart drawer re-renders (Dawn swaps #CartDrawer's innerHTML).
  var drawer = document.getElementById('CartDrawer');
  if (drawer && 'MutationObserver' in window) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 50);
    }).observe(drawer, { childList: true, subtree: true });
  }
})();
